import { InfoLeagueProps } from '../leagues.props';
import { RedBeryl } from './RedBeryl';

export const RedBerylLeague: InfoLeagueProps = {
  id: `${process.env.REACT_APP_ID_LEAGUE_RED_BERYL}`,
  icon: '🔥',
  name: 'Berilio Rojo',
  description: 'El fuego de los emperadores. Botines legendarios.',
  active: false,
  color: '#FFFFFF',
  bgColor: '#E34234',
  borderColor: '#E34234',
  path: '/red-beryl',
  page: RedBeryl,
};
